import { Promise } from "./Promise";
import { Antiforgery } from "../Utils/Antiforgery";

import * as $ from "jquery";
/* eslint-disable @typescript-eslint/no-unused-vars*/
export class AjaxWrapper {
    public static post<TResult, TErrors>(url: string, data: any): Promise<TResult, TErrors> {
        return this.sendRequest("POST", url, JSON.stringify(data));
    }

    public static put<TResult, TErrors>(url: string, data: any): Promise<TResult, TErrors> {
        return this.sendRequest("PUT", url, JSON.stringify(data));
    }

    public static delete<TResult, TErrors>(url: string, data: any): Promise<TResult, TErrors> {
        return this.sendRequest("DELETE", url, JSON.stringify(data));
    }

    public static get<TResult, TErrors>(url: string, data?: any): Promise<TResult, any> {
        return this.sendRequest("GET", url, data);
    }

    private static sendRequest<TResult, TErrors>(
        methodType: string,
        url: string,
        data?: any
    ): Promise<TResult, TErrors> {
        return new Promise<TResult, TErrors>((onSuccess, onError) => {
            $.ajax(this.constructAjaxParams(methodType, url, data)).then(
                (data: any) => {
                    if (data.Errors && data.Errors.length && data.Errors.length > 0) {
                        onError(data.Errors);
                    } else {
                        onSuccess(data.Result);
                    }
                },
                (request, status, errors) => {
                    if (status === "parsererror" && request.status === 200) {
                        // Won't have security issue, it only return when exception error happened in serve-side and the response can't be manipulated from XSS attack
                        const newDoc = document.open("text/html", "replace");
                        newDoc.write(request.responseText);
                        newDoc.close();
                    }
                }
            );
        });
    }

    private static constructAjaxParams(methodType: string, url: string, data: any): JQueryAjaxSettings {
        url = "/wpadviser" + url;
        const result: JQueryAjaxSettings = {
            type: methodType,
            url: url,
            data: data,
            accepts: { key: "application/json" },
            dataType: "json",
        };

        if (methodType !== "GET") {
            result.contentType = "application/json; charset=utf-8";
        }

        if (methodType === "GET") {
            result.traditional = true;
        }

        const antiforgeryToken: string = Antiforgery.getAntiforgeryTokenValue();
        if (antiforgeryToken) {
            result.headers = { "anti-forgery-token": antiforgeryToken };
        }

        return result;
    }
}
